import { cn } from '@/lib/utils';
import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export const Card: React.FC<CardProps> = ({ className = '', onClick, children }) => {
  return (
    <div
      className={cn(
        'w-full mx-auto shadow-md bg-white dark:bg-dark-gray-800 rounded-md px-4 py-6 sm:p-6 dark:text-dark-gray-200 border border-gray-200 dark:border-dark-gray-800',
        className
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
};
